import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ProgressWrapper = styled.div`
  width: 100%;
  position: fixed;
  top: -30px;
  left: 0;
  height: 5px;
  background: rgb(54,51,60);
  z-index: 40;
  box-shadow: 0 2px 4px rgba(0,0,0,0.45);
  transition: top 0.2s ease-out;
  &.viewable {
    top: 0px;
  }
`;

const Bar = styled.div`
  height: 5px;
  background-color: var(--custom-red);
  border-radius: 1px;
`;

const ProgressBar = ({ audioData, stickyView }) => {
  const [progress, setProgress] = useState(0);

  const audioMarkersRef = useRef();
  useEffect(() => {
    const updateProgress = () => {
      const scrollHeight = document.documentElement.scrollTop;
      // eslint-disable-next-line
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      setProgress((scrollHeight / windowHeight) * 100);
    };

    window.addEventListener('scroll', updateProgress);

    return () => window.removeEventListener('scroll', updateProgress);
  }, [audioData]);

  return (
    <ProgressWrapper className={stickyView ? 'viewable' : null}>
      <Bar
        style={{ width: `${progress}%` }}
      />
      {audioMarkersRef.current}
    </ProgressWrapper>
  );
};

export default ProgressBar;

ProgressBar.propTypes = {
  audioData: PropTypes.arrayOf(
    PropTypes.shape(),
  ).isRequired,
  stickyView: PropTypes.bool.isRequired,
};
